const getBaseUrl = hostEnv => {
  if (hostEnv === 'qa') {
    return 'https://qa-beta.theknot.com/';
  } else if (hostEnv === 'production') {
    return 'https://www.theknot.com/';
  }

  return '/';
};

const generateFormLinks = function () {
  let hostEnv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : process.env.UNION_DEPLOYMENT_ENV;

  const withHost = relUrl => `${getBaseUrl(hostEnv)}${relUrl}`;

  return {
    FORGOT_PASSWORD: withHost('account/forgot-password/provide-email'),
    PRIVACY_POLICY: withHost('privacy-policy'),
    TERMS_AND_CONDITIONS: withHost('terms-and-conditions')
  };
};

export default generateFormLinks;